module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || 'l7i8a0bi',
    dataset: process.env.GATSBY_SANITY_DATASET || 'production'
  }
}
